import script from "./BoardChartModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardChartModal.vue?vue&type=script&setup=true&lang=ts"

import "./BoardChartModal.vue?vue&type=style&index=0&id=1b19afcf&scoped=true&lang=css"
import "./BoardChartModal.vue?vue&type=style&index=1&id=1b19afcf&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b19afcf"],['__file',"BoardChartModal.vue"]])

export default __exports__